import { useEffect, useRef } from 'react';
import { eventNameConstants, trackEcommerce, trackingConstants } from 'dibs-tracking';

const commonArgs = {
    name: 'NFT Banner Carousel',
    id: 'nft-banner-carousel',
    creative: '/nft-collections/',
};

const { ECOM_PRODUCT_PROMO_IMPRESSION, ECOM_PRODUCT_PROMO_CLICK } = trackingConstants;
const { EVENT_VIEW_PROMOTION, EVENT_SELECT_PROMOTION } = eventNameConstants;

const trackBanner = (
    type: typeof ECOM_PRODUCT_PROMO_IMPRESSION | typeof ECOM_PRODUCT_PROMO_CLICK,
    position: number
): void => {
    const noninteraction = type === ECOM_PRODUCT_PROMO_IMPRESSION ? 0 : undefined;
    const eventNames = {
        [ECOM_PRODUCT_PROMO_IMPRESSION]: EVENT_VIEW_PROMOTION,
        [ECOM_PRODUCT_PROMO_CLICK]: EVENT_SELECT_PROMOTION,
    };

    trackEcommerce({
        type,
        eventName: eventNames[type],
        noninteraction,
        promotions: [{ ...commonArgs, position }],
    });
};

export function trackClick(position: number): void {
    trackBanner(ECOM_PRODUCT_PROMO_CLICK, position);
}

export const useTrackViewOnce = (isVisible: boolean | undefined, position: number): void => {
    const hasTrackedRef = useRef(false);
    useEffect(() => {
        if (isVisible && !hasTrackedRef.current) {
            hasTrackedRef.current = true;
            trackBanner(ECOM_PRODUCT_PROMO_IMPRESSION, position);
        }
    }, [isVisible, position]);
};
